import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about">
      <p className="border-below"></p>
      <h2>About Me</h2>
      <div className="about-section-with-media">
        <video
          className="about-media drop-shadow-thick"
          src="/marketingPages/about/write-look.mp4"
          autoPlay
          muted
          playsInline
          onMouseEnter={(e) => {
            e.target.currentTime = 0;
            e.target.play();
          }}
          onMouseLeave={(e) => {
            e.target.pause();
            e.target.currentTime = 0;
          }}
        />
        <p>
          I started writing and sharing songs as a teenager, and over the years
          it has become a central part of who I am and often a reflection of my
          own prayer life. This ministry was born out of a deep desire to lift
          up Jesus through music, sharing my life with Him and the songs He's
          given me with others. My prayer is that these songs would draw people
          into a closer relationship with Him, awakening their hearts to His
          love and presence. If you don't know Jesus yet, I pray these songs
          would help you encounter Him in a real way. If you do know Him, I pray
          these songs would deepen your love for Him and inspire you to worship
          Him more fully.
        </p>
      </div>
      <p className="border-below"></p>
      <h2>
        What does <em>BelovedzGuard</em> mean?
      </h2>

      <p>
        It’s a name with layers of meaning. First and foremost, it reflects my
        identity as His beloved and the calling He’s given me to guard and
        strengthen others who are also His beloved. That’s why my logo is a
        female knight: I stand as a guard through the work He’s given me,
        protecting hearts through truth, beauty, and worship - with His help,
        always.
      </p>
      <p className="border-below"></p>
      <h2>Artist Statement</h2>

      <div className="about-section-with-media media-right">
        <video
          className="about-media drop-shadow-thick"
          src="/marketingPages/about/prayer.mp4"
          autoPlay
          muted
          playsInline
          onMouseEnter={(e) => {
            e.target.currentTime = 0;
            e.target.play();
          }}
          onMouseLeave={(e) => {
            e.target.pause();
            e.target.currentTime = 0;
          }}
        />
        <p>
          I write songs to awaken the bride with love for her bridegroom, the
          Lord Jesus.
        </p>

        <p>
          I create from a place of personal intimacy, drawing from the depths of
          a heart fully given to Him. My music is shaped by worship, longing,
          Scripture, and the Spirit's presence. Mostly, they are prayers.
          Prayers of surrender, adoration, cries of pain and determined faith.
          These songs are meant to call others into the same kind of closeness
          with Him: to see His glory, feel His love, and respond with all they
          are.
        </p>
      </div>
      <p className="border-below"></p>
      <p>
        <strong>Disclaimer:</strong> I am not a professional musician or part of
        the music industry. All lyrics, melodies, concepts, and creative direction are my
        own. The accompanying music, vocal performances, and visuals are produced using
        various online and often AI-based tools, including but not
        limited to generative AI platforms such as Suno and AI assisted sites like Canva. These tools are used to bring my
        original songs to life.
      </p>
      <p>
        By engaging with or supporting my work or content, you acknowledge that
        AI-assisted technology was used in the creation of the musical
        components and some images, and that I have made this disclosure openly
        and in good faith.
      </p>
    </div>
  );
};

export default About;
